import {NavLink, useLocation} from "react-router-dom";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import CalculateIcon from '@mui/icons-material/Calculate';
import PeopleIcon from '@mui/icons-material/People';
import ViewListIcon from '@mui/icons-material/ViewList';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import React from "react";
import {useAuthContext} from "../../contexts/AuthContext";
import {useUserContext} from "../../contexts/UserContext";
import {useMediaQuery} from "react-responsive";
import {barHeight} from "./AppMobileNav";
import CookieService from '../../utils/CookieService'
import {mediaQueryForMobile} from "./HomePage";
import {useCalcContext} from "../../contexts/CalcContext";

export const AppNavLinks = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { logout } = useAuthContext()
    const { profileState, isFeatureFlagEnabled } = useUserContext()
    const { resetCalcState } = useCalcContext()
    let location = useLocation();
    const pathname = location.pathname
    const pathnameSplit = pathname.split('/')[1]

    const isPricingPath = pathnameSplit === 'pricing'
    const isCalculatePath = pathnameSplit === 'calculate'
    const isCRMPath = pathnameSplit === 'leads' || pathnameSplit === 'clients'

    const lastPricingRoute = () => {
        return profileState?.pages_visited?.find((route) => route.includes('/pricing/')) || '/pricing/honda'
    }

    const clientversion = CookieService.getItem("clientversion")
    const shouldReloadDoc = Boolean(clientversion !== String(process.env.REACT_APP_VERSION))

    return (
        <div className={'AppNavLinks'}>
            {
                isTabletOrMobile ? <div style={{height: `${barHeight}px`}}></div> : null
            }
            <div className={'AppSidebarNav-top'}>
                <div className={'navlink-container'}>
                    <NavLink
                        reloadDocument={shouldReloadDoc}
                        onClick={() => {
                            if (isCalculatePath) {
                                resetCalcState()
                            }
                        }}
                        to="/calculate"
                        className={({ isActive, isPending, isTransitioning }) =>
                            [
                                "navlink",
                                isPending ? "pending" : "",
                                isActive ? "active" : "",
                                isTransitioning ? "transitioning" : "",
                            ].join(" ")
                        }
                    >
                        <CalculateIcon/> <span>Calculate</span>
                    </NavLink>
                    <NavLink
                        reloadDocument={shouldReloadDoc}
                        to="/quotes"
                        className={({ isActive, isPending, isTransitioning }) =>
                            [
                                "navlink",
                                isPending ? "pending" : "",
                                isActive ? "active" : "",
                                isTransitioning ? "transitioning" : "",
                            ].join(" ")
                        }
                    >
                        <RequestQuoteIcon/> <span>Quotes</span>
                    </NavLink>
                    {
                        !isTabletOrMobile &&
                        <NavLink
                            reloadDocument={shouldReloadDoc}
                            to={lastPricingRoute()}
                            className={({ isActive, isPending, isTransitioning }) =>
                                [
                                    "navlink",
                                    isPending ? "pending" : "",
                                    isPricingPath ? "active" : "",
                                    isTransitioning ? "transitioning" : "",
                                ].join(" ")
                            }
                        >
                            <ViewListIcon/> <span>Pricing Index</span>
                        </NavLink>
                    }
                    {
                        isFeatureFlagEnabled('crm') && !isTabletOrMobile &&
                        <NavLink
                            reloadDocument={shouldReloadDoc}
                            to="/leads"
                            className={({ isActive, isPending, isTransitioning }) =>
                                [
                                    "navlink",
                                    isPending ? "pending" : "",
                                    isCRMPath ? "active" : "",
                                    isTransitioning ? "transitioning" : "",
                                ].join(" ")
                            }
                        >
                            <PeopleIcon/> <span>CRM</span>
                        </NavLink>
                    }
                </div>

            </div>
            <div className={'AppSidebarNav-bottom'}>
                <NavLink
                    reloadDocument={shouldReloadDoc}
                    to="/quote-settings"
                    className={({ isActive, isPending, isTransitioning }) =>
                        [
                            "navlink",
                            isPending ? "pending" : "",
                            isActive ? "active" : "",
                            isTransitioning ? "transitioning" : "",
                        ].join(" ")
                    }
                >
                    <SettingsSuggestIcon/> <span>Settings</span>
                </NavLink>
                <NavLink
                    reloadDocument={shouldReloadDoc}
                    to="/account/profile"
                    className={({ isActive, isPending, isTransitioning }) =>
                        [
                            "navlink",
                            isPending ? "pending" : "",
                            isActive ? "active" : "",
                            isTransitioning ? "transitioning" : "",
                        ].join(" ")
                    }
                >
                    <PersonIcon/> <span>Profile</span>
                </NavLink>
                <div className={'navlink'} onClick={() => logout()}>
                    <LogoutIcon/> <span>Log out</span>
                </div>
            </div>
        </div>
    )
}